import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, from, of } from "rxjs";
import { CONTRACTS_ABI, contractAddress, eContracts } from "./contract.config";
import { Web3Service, networkSettings } from "../web3/web3.service";

// declare const window

@Injectable({
    providedIn: 'root'
})

export class ContractsService {
    // private _contractInstance: ReplaySubject<any> = new ReplaySubject<any>(1);
    // private _contracts: Map<eContracts, ReplaySubject<any>> = new Map<eContracts, ReplaySubject<any>>();
    private contracts: Map<eContracts, any> = new Map<eContracts, any>();
    apiEndPoint: string;

    constructor(private web3Service: Web3Service) { }

    //getContract will set if it is not set yet a contract and return itself
    getContract(contractName: eContracts): any {
        /* return this._contracts.get(contract).asObservable(); */
        this.setContract(contractName);
        return this.contracts.get(contractName);
    }

    setContract(contractName: eContracts) {
        /* if (!this.contracts.get(contractName)) {
            let abi = CONTRACTS_ABI().filter(c => c.name === contractName)[0].abi;
            let address = contractAddress[this.networkName][contractName];
            this._contracts.set(contractName, new ReplaySubject<any>(1))
            this._contracts.get(contractName).next(new web3.eth.Contract(abi, address));
        } */
        let web3 = this.web3Service.getWeb3();
        let networkName = this.web3Service.getNetworkName();
        if (!this.contracts.get(contractName)) {
            let abi = CONTRACTS_ABI().filter(c => c.name === contractName)[0].abi;
            let address = contractAddress[networkName][contractName];
            this.contracts.set(contractName, new web3.eth.Contract(abi, address));
        }
    }
    // setContractInstance(web3, abi: any, address: string) {
    //     this._contractInstance.next(new web3.eth.Contract(abi, address));
    // }



    getContractAddress(contract: eContracts): string {
        let networkName = this.web3Service.getNetworkName();
        return contractAddress[networkName][contract];
    }


    //Maybe set all is not necessary
    /* setAllContractsInstances(web3: any, networkName: string) {
        this.networkName = networkName;
        if (networkName in environment.allowedNetwork) CONTRACTS_ABI().forEach(c => this.setContractInstances(web3, c.name, c.abi, contractAddress[networkName][c.name]));
        else {
            //Wrong Network
            const params = [networkSettings[environment.allowedNetwork[0]]];
 
            window.ethereum.request({ method: 'wallet_addEthereumChain', params })
                .then(() => console.log('Success'))
                .catch((error: Error) => console.log("Error", error.message));
        }
    } */
    // setContractInstances(web3: any, contractName: eContracts, abi: any, address: string) {
    //     //used only for setAllContracsInstances
    //     /* this._contracts.set(contract, new ReplaySubject<any>(1));
    //     this._contracts.get(contract).next(new web3.eth.Contract(abi, address)); */

    //     this.contracts.set(contractName, new web3.eth.Contract(abi, address))
    // }

    //OLD WAY
    // setContractInstancesByNetwork(web3: any, networkName: string) {
    //     this.networkName = networkName;
    //     switch (networkName) {
    //         case 'BinanceSmartProd':
    //             this.apiEndPoint = apiEndPointByNetwork[networkName];
    //             BINANCESMARTPROD().forEach(c => this.setContractInstances(web3, c.name, c.abi, c.address));
    //             this._contracts.get(eContracts.contractMerkleMB).pipe(first()).subscribe(async c => {
    //                 const purchaseToken = await c.methods.paymentToken().call();
    //                 this.setContractInstances(web3, eContracts.contractMBPurchaseToken, abi.tokenAbiJson, purchaseToken);
    //             });
    //             break;
    //         case 'Rinkeby':
    //             this.apiEndPoint = apiEndPointByNetwork[networkName];
    //             RINKEBY().forEach(c => this.setContractInstances(web3, c.name, c.abi, c.address));
    //             this._contracts.get(eContracts.contractMerkleMB).pipe(first()).subscribe(async c => {
    //                 const purchaseToken = await c.methods.paymentToken().call();
    //                 this.setContractInstances(web3, eContracts.contractMBPurchaseToken, abi.tokenAbiJson, purchaseToken);
    //             });
    //             break;
    //         case 'BinanceSmart':
    //             BINANCESMART().forEach(c => this.setContractInstances(web3, c.name, c.abi, c.address));
    //             break;
    //         default:
    //             //Wrong Network
    //             const params = [{
    //                 chainId: '0x38',
    //                 chainName: 'Smart Chain',
    //                 nativeCurrency: {
    //                     name: 'BNB',
    //                     symbol: 'BNB',
    //                     decimals: 18
    //                 },
    //                 rpcUrls: ['https://bsc-dataseed.binance.org/'],
    //                 blockExplorerUrls: ['https://bscscan.com']
    //             }]

    //             window.ethereum.request({ method: 'wallet_addEthereumChain', params })
    //                 .then(() => console.log('Success'))
    //                 .catch((error: Error) => console.log("Error", error.message));
    //             break;
    //     }
    // }

    // getContractInfo(contract: eContracts): IContract {
    //     let contractInfo: IContract;
    //     switch (this.networkName) {
    //         case 'BinanceSmartProd':
    //             contractInfo = BINANCESMARTPROD().filter(c => c.name === contract)[0];
    //             break;
    //         case 'Rinkeby':
    //             contractInfo = RINKEBY().filter(c => c.name === contract)[0];
    //             break;
    //         case 'BinanceSmart':
    //             contractInfo = BINANCESMART().filter(c => c.name === contract)[0];
    //             break;
    //         default:
    //             contractInfo = null;
    //             break;
    //     }
    //     return contractInfo;
    // }
}
// const web3Modal = new Web3Modal({
//     providerOptions, cacheProvider: true // required
// });


// export enum eContracts {
//     KMONFT = 'KMONFT',
//     KMONFTV2 = 'KMONFTV2',
//     KMONToken = 'KMONToken',
//     merkleInstance = 'merkleInstance',
//     merkleInstance2 = 'merkleInstance2',
//     merkleInstance3 = 'merkleInstance3',
//     merkleInstance4 = 'merkleInstance4',
//     merkleEggHunt = 'merkleEggHunt',
//     merkleEggHunt2 = 'merkleEggHunt2',
//     AirdropMerkleInstance = 'AirdropMerkleInstance',
//     Lottery = 'Lottery',
//     oldLottery = 'oldLottery',
//     contractRewardsInstance = 'contractRewardsInstance',
//     newContractRewardsInstance = 'newContractRewardsInstance',
//     contractMerkleLoreInstance = 'contractMerkleLoreInstance',
//     contractMerkleLoreInstance2 = 'contractMerkleLoreInstance2',
//     newContractRewardsInstanceLP = 'newContractRewardsInstanceLP',
//     contractLPInstance = 'contractLPInstance',
//     contractRedeemNFTInstance = 'contractRedeemNFTInstance',
//     contractPartnerInstance = 'contractPartnerInstance',
//     contractRedeemNFTInstance2 = 'contractRedeemNFTInstance2',
//     contractPartnerInstance2 = 'contractPartnerInstance2',
//     contractBuyMysteryBoxMerkleInstance = 'contractBuyMysteryBoxMerkleInstance',
//     contractBuyTokenInstance = 'contractBuyTokenInstance',
//     contractAirdropMerkleInstance2 = 'contractAirdropMerkleInstance2',
//     contractCryptoCom = 'contractCryptoCom',
//     contractCryptoCom2 = 'contractCryptoCom2',
//     contractMerkleMB = 'contractMerkleMB',
//     pancakeV2 = 'pancakeV2',
//     WBNB = 'WBNB',
//     marketplaceContract = 'marketplaceContract',
//     lootboxesContract = 'lootboxesContract',
//     contractMBPurchaseToken = 'contractMBPurchaseToken',
//     playdexContract = 'playdexContract'
// }

